import { GeneralQuestionUIConfig, GeneralQuestionUIConfigOption } from "../../../../../cvp-webgames-core/Components/ui/react/core-general-question-ui";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { ScoringType } from "../../../../../misc/tools";
import { GameBaseScenario } from "../../../../GameBaseScenario";
import { scenario4WcWorkStoppageAudioCaching, scenario4WcWorkStoppageVideoSegments } from "../../../scenario4-wc-work-stoppage";
import { WcWorkStoppageComponentsStep0ComponentMainConfig, WcWorkStoppageComponentsStep0ComponentPart1Config } from "../wc-work-stoppage-components-step0";

export default class WcWorkStoppageComponentsStep0Part1 extends BaseScenarioPart<GameBaseScenario> {
	private get config(): WcWorkStoppageComponentsStep0ComponentPart1Config {
		return this.mainConfig.part1Config;
	}
	constructor(scenario: GameBaseScenario, private onDone: () => void, private id: string, private mainConfig: WcWorkStoppageComponentsStep0ComponentMainConfig) {
		super(scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	private stepName = 'Step 1';

	public start() {
		this.section1();
	}

	public section1() {
		const context = this;
		let chapter = context.config.chapter;
		context.playVideoChapter(chapter(), () => {
			context.section2();
		})
	}

	public section2() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			title: this.mainConfig.scenario.props.name,
			audioUrl: scenario4WcWorkStoppageAudioCaching.getItemByKey(scenario4WcWorkStoppageAudioCaching.audioKeys.question1).src,
			subtitle: (this.stepName + ' - Question 1'),
			questionTitle: 'Select the one that best describes the employee\'s action ',
			options: [
				{
					title: 'Human Error',
					description: `
						<ul>
						<li>The employee is not accountable.</li>
						<li>The employee should be consoled.</li>
						<li>The employee should be interviewed and consulted during any systems level analysis.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Dr. Jones did not commit an error 
						while working appropriately and in the patient’s best interest.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'At Risk Behavior',
					description: `
						<ul>
						<li>The employee is accountable and should receive coaching.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">This is not the best option. Dr. Jones consciously made an unsafe 
						choice and did so with little regard for the risk created. Also, it is important to consider 
						that a staff physician is well trained on the appropriate aseptic technique to prevent 
						infection. In addition, the comments of the staff physician focus on individual frustrations 
						and needs rather than what is best for the patient. The level of risk created in this situation 
						cannot be justified. This is considered reckless behavior.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Reckless Behavior',
					description: `
						<ul>
						<li>Discipline may be warranted.</li>
						<li>The employee is accountable and should receive re-training/coaching as necessary.</li>
						<li>The employee may participate in teaching others the lessons learned.</li>
						</ul>
					`,
					feedbackHtml: `
						<p class="default-text">Correct. Dr. Jones consciously made an unsafe choice and did so 
						with little regard for the risk created. Also, it is important to consider that a staff 
						physician is well trained on the appropriate aseptic technique to prevent infection. In addition, 
						the comments of the staff physician focus on individual frustrations and needs rather than what 
						is best for the patient. The level of risk created in this situation cannot be justified. 
						This is considered reckless behavior.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 1'), parentQuestionConfig, () => {
					this.section3();
				}, () => {
					this.section3();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[0], mentorInfo.chapterIds[1], mentorInfo.chapterIds[2], 'Human Error');
			}
		}, 0);
	}

	public section3() {
		const context = this;
		this.mainConfig.scenario.uiWrapper.displayQuestonType1UI({
			audioUrl: scenario4WcWorkStoppageAudioCaching.getItemByKey(scenario4WcWorkStoppageAudioCaching.audioKeys.question2).src,
			title: this.mainConfig.scenario.props.name,
			subtitle: (this.stepName + ' - Question 2'),
			questionTitle: 'Based on the correct answer, what is the appropriate path to take with the employee ',
			options: [
				{
					title: 'Console',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the most complete option.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console and coach',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">This is not the most complete option.</p>
					`,
					isCorrect: false,
					score: ScoringType.bad
				},
				{
					title: 'Console, coach, and consider discipline',
					description: 'Select and submit an option.',
					feedbackHtml: `
						<p class="default-text">Correct. Responses may involve formal discipline per agreements in place when behaviors are found reckless.</p>
					`,
					isCorrect: true,
					score: ScoringType.good
				}
			],
			
			onSubmitClicked: (allOptions: GeneralQuestionUIConfigOption[], selectedChoices: GeneralQuestionUIConfigOption[], parentQuestionConfig: GeneralQuestionUIConfig) => {
				const mentorInfo = scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback');
				context.scenario.onChoiceSubmittedQuestionType1(selectedChoices[0], (this.stepName + ' - Question 2 '), parentQuestionConfig, () => {
					this.onDone();
				}, () => {
					this.onDone();
				}, undefined, undefined, undefined, mentorInfo.src, mentorInfo.chapterIds[3], mentorInfo.chapterIds[4], mentorInfo.chapterIds[5], 'Console');
			}
		}, 1);
	}
}